import Slider from './Slider';

class SliderGallery extends Slider {
  // HTML element of thumbs' slider
  $thumbs: HTMLElement;
  // Initialized thumbnails swiper element
  thumbSlider: any;
  // HTML element list of thumb's inner elements
  $$thumbs: NodeListOf<HTMLElement>;

  beforeMount() {
    this.$thumbs = this.$slider.querySelector('[data-slider-thumbs]');

    this.thumbSlider = new this.swiperModule(this.$thumbs, {
      centeredSlides: true,
      slidesPerView: 5,
      loopedSlides: 6,
      loop: true,
      slideActiveClass: 'is-active',
      simulateTouch: false,
      speed: 800,
    });

    return this;
  }

  public updateOptions() {
    return {
      controller: {
        control: this.thumbSlider,
      },
      loopedSlides: 6,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    };
  }

  public afterMount() {
    this.autoToggleVideo();
    this.$$thumbs = this.$slider.querySelectorAll('[data-slider-thumb]');
    this.thumbSlider.controller.control = this.slider;

    [].forEach.call(this.$$thumbs, ($thumb, i) => {
      $thumb.addEventListener('click', () => this.thumbSlider.slideTo(i, 800));
    });
    return this;
  }
}

export default SliderGallery;
